import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, formatErr } from "../lib/auth";
import TopNav from "../components/TopNav";
import { Shield } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email.trim(), password);
      nav("/dashboard");
    } catch (e2) {
      setErr(formatErr(e2?.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg)] flex flex-col">
      <TopNav landing />
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md flat-card p-8 scanlines" data-testid="login-card">
          <div className="flex items-center gap-3 mb-2">
            <Shield size={22} color="var(--cyan)" strokeWidth={1.5} />
            <div className="overline">// AUTH_REQUIRED</div>
          </div>
          <h1 className="font-display font-bold text-3xl uppercase tracking-tight mb-1">Operator Login</h1>
          <p className="text-sm text-[var(--text-2)] mb-6">Authenticate to access mission systems.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-mono text-xs tracking-widest uppercase text-[var(--text-2)]">Email</label>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-tac mt-1" placeholder="you@yourcompany.com"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="font-mono text-xs tracking-widest uppercase text-[var(--text-2)]">Password</label>
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-tac mt-1" placeholder="••••••••"
                data-testid="login-password"
              />
            </div>

            {err && <div className="font-mono text-xs text-[var(--red)] border border-[var(--red)] p-2" data-testid="login-error">{err}</div>}

            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
              {busy ? "Authenticating…" : "Authenticate"}
            </button>
          </form>

          <div className="mt-4 text-right">
            <Link to="/forgot-password" className="font-mono text-xs tracking-widest uppercase text-[var(--text-2)] hover:text-[var(--cyan)]" data-testid="login-forgot-password">
              Forgot password?
            </Link>
          </div>

          <div className="mt-6 text-sm text-[var(--text-2)]">
            Don&apos;t have an account? <Link to="/register" className="text-[var(--cyan)] hover:underline" data-testid="login-to-register">See access options</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
